import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpService } from '../../shared/services/http/http-client.service';
import { HttpClient } from '@angular/common/http';

const API = environment.url_server;
@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  protected urlBase = environment.url_server;

  constructor(private http: HttpClient, private httpService: HttpService) { }


  productIdentify(data: any, successHandle: Function, errorHandle: Function) {

     this.httpService.doGet('/auth/identifyProduct', data, successHandle, errorHandle);

  }

  buscaCliente(data: any, successHandle: Function, errorHandle: Function) {

    this.httpService.doGet('/enterprise', data, successHandle, errorHandle);

  }

  identifyCompany(data: any, successHandle: Function, errorHandle: Function) {

    this.httpService.doGet('/auth/identifyEnterprise', data, successHandle, errorHandle);

  }

  balanceDetailViewList(data: any, successHandle:Function, errorHandle:Function) {

    this.httpService.doGet('/enterprise/retailAccountBalance', data, successHandle, errorHandle);

 }

 balanceValorRecebiveis(data: any, successHandle:Function, errorHandle:Function) {

  this.httpService.doGet('/enterprise/returnRetailReceivablesBalance', data, successHandle, errorHandle);

}

 findAgilliSales(data: any, successHandle: Function, errorHandle: Function) {
  this.httpService.doPost('/agilli/getMySales', data, successHandle, errorHandle);
 }

 findAgilliEarnings(data: any, successHandle: Function, errorHandle: Function) {
  this.httpService.doPost('/agilli/summaryEarnings', data, successHandle, errorHandle);
 }

 findAgilliFutureEarnings(data: any, successHandle: Function, errorHandle: Function) {
  this.httpService.doPost('/agilli/summaryFutureEarnings', data, successHandle, errorHandle);
 }


 findAgilliSalesPromise(data: any) {
  return this.http.post(this.urlBase + '/agilli/getMySales', data);
 }

 findAgilliEarningsPromise(data: any) {
  return this.http.post(this.urlBase + '/agilli/summaryEarnings', data);
 }

 findAgilliFutureEarningsPromise(data: any) {
  return this.http.post(this.urlBase + '/agilli/summaryFutureEarnings', data );
 }

 productIdentifyPromise(data: any) {

  return this.http.get(this.urlBase +  '/auth/identifyProduct', {params: data});

}

retailAccountBalanceBlocked(data: any, successHandle:Function, errorHandle:Function) {

  this.httpService.doGet('/enterprise/retailAccountBalanceBlocked', data, successHandle, errorHandle);

}

receivablesCerc(data: any, successHandle: Function, errorHandle: Function) {

  this.httpService.doGet('/enterprise/sumReceivablesCerc', data, successHandle, errorHandle);

}

}
